// main.js
import "vite/modulepreload-polyfill";

import "destyle.css/destyle.css";

import "@/assets/scss/app.scss";

// 共通処理
import "@/js/common/header.js";

import {
  initAnimations,
  refreshScrollTrigger,
} from "@/js/common/animation.js";
import { initModal } from "@/js/common/modal.js";
import { initSnapScroll } from "@/js/common/snap-scroll.js";
import { initFooterPagetop } from "@/js/common/page-top.js";
import { initCommonLinks } from "@/js/common/links.js";

// ページ別処理
import { initTopPage } from "@/js/pages/top.js";
import { initMember } from "@/js/pages/member.js";
import { initRecruitPage } from "@/js/pages/recruit.js";
import { initPlacementPage } from "@/js/pages/service-placement.js";
import { initMaximCard } from "@/js/pages/maxim-card.js";

document.addEventListener("DOMContentLoaded", () => {
  // 共通アニメーション
  initAnimations();

  // スナップスクロール
  initSnapScroll();

  // 汎用モーダル
  initModal();

  // ページトップ
  initFooterPagetop();

  // 共通リンク
  initCommonLinks();

  // ページ別処理
  initTopPage();
  initMember();
  initRecruitPage();
  initPlacementPage();
  initMaximCard();
});

window.addEventListener("load", () => {
  refreshScrollTrigger();
});